'use client'
import React from 'react';
import { SectionContent } from "@/types/sections.model";
import { Box, Container, Grid, Typography } from "@mui/material";
import Row from "../ui/Row";
import FadeIn from "../ui/FadeIn";
import { useWindowSize } from "@/hook/useWindowSize";
import Media from '../ui/Media';

const Testimonial: React.FC<{ section: SectionContent<'testimonial'> }> = ({ section }) => {
  const { id, content, style, items, reverse } = section;
  const { isMobile } = useWindowSize();

  const justifyContent = style?.alignment || 'flex-start';
  const textAlign = style?.alignment === 'center' ? 'center' : 'left';

  return (
    <>
      <Box
        id={id}
        sx={{
          pt: {xs: 32, lg:48},
        }}
      >
        <Container>
          <Row justifyContent={justifyContent}>
            {(content.title || content.subtitle) && (
              <Grid size={{xs: 12, lg: 8}} textAlign={textAlign} mb={6}>
                <FadeIn>
                  {content.title && (
                    <Typography variant="displaySM" component={"h2"} mb={2}>
                      {content.title}
                    </Typography>
                  )}
                  {content.subtitle && (
                    <Typography variant="headlineMDMedium" component={"p"}>
                      {content.subtitle}
                    </Typography>
                  )}
                </FadeIn>
              </Grid>
            )}

            {/* Asymmetric Layout */}
            {items && items.length >= 2 && (
              <Grid size={12} pt={{xs: 14, lg: 0}}>
                <Row
                  rowSpacing={12}
                  flexDirection={{
                    xs: "column-reverse",
                    lg: reverse ? "row-reverse" : "row"
                  }}
                  justifyContent={{
                    lg: "space-between"
                  }}
                  alignItems={{ xs: reverse ? 'flex-start' : 'flex-end', lg: "stretch" }}
                >
                  {/* Large Item */}
                  <Grid size={{xs: 12, lg: 8}} pt={{lg: 75}}>
                    <FadeIn>
                      <Media item={items[0]} isLarge />
                    </FadeIn>
                  </Grid>

                  {/* Small Items Column */}
                  <Grid size={{xs: 6, lg: 3}} pb={{lg: 42}}>
                    {items.slice(1).map((item, index) => (
                      <Box key={index} sx={{ flex: 1 }}>
                        <FadeIn transition={{ delay: isMobile ? 0 : index * 0.2 }}>
                          <Media item={item} />
                        </FadeIn>
                      </Box>
                    ))}
                  </Grid>
                </Row>
              </Grid>
            )}
          </Row>
        </Container>
      </Box>
    </>
  );
};

export default Testimonial;